import React, { useState } from 'react';

import { useForm } from 'react-hook-form';

import BlurPopup from 'components/BlurPopup';
import { Button } from 'components/Buttons/Button';
import { ButtonType } from 'enums/ButtonType';
import useMobileCheck from 'hooks/useMobileCheck';
import FormBody from 'components/FormBody';
import LoanOfferInfo from 'pages/Dashboard/steps/AcceptOffer/AcceptAutomatedOffer/ConfirmOfferPopup/LoanOfferInfo/LoanOfferInfo';
import Loader from 'components/Loader/index';
import { FormValues } from 'pages/Dashboard/steps/AcceptOffer/AcceptAutomatedOffer/ConfirmOfferPopup/confirmOfferPopup.types';
import { OfferDto } from 'api/AutomatedOffersApi';
import styles from 'pages/Dashboard/steps/AcceptOffer/AcceptAutomatedOffer/ConfirmOfferPopup/ConfirmOfferPopup.module.scss';
import CreditServicesAgreementPopup from 'pages/Dashboard/steps/AcceptOffer/CreditServicesAgreementPopup/CreditServicesAgreementPopup';
import { Lender } from 'enums/ApplicationsVariables';

interface ConfirmOfferPopupProps {
  isModalOpen: boolean;
  onClose: () => void;
  onSubmit: () => Promise<void>;
  cashToYou: number;
  loanOffer: OfferDto;
}

const ConfirmOfferPopup = ({ isModalOpen, onClose, onSubmit, loanOffer, cashToYou }: ConfirmOfferPopupProps) => {
  const [isLoading, setIsLoading] = useState(false);
  const isMobile = useMobileCheck();
  const [isCreditServiceAgreementPopupOpen, setIsCreditServiceAgreementPopupOpen] = useState(false);
  const { handleSubmit, trigger } = useForm<FormValues>({
    defaultValues: {},
    shouldFocusError: true,
  });

  const handleAcceptOffer = handleSubmit(async () => {
    setIsLoading(true);
    await onSubmit();
    setIsLoading(false);
  });

  const handleCloseCreditServiceAgreementPopup = () => {
    setIsCreditServiceAgreementPopupOpen(false);
  };

  const handleOpenCreditServiceAgreementPopup = async () => {
    const validationResult = await trigger();

    if (!validationResult) {
      return;
    }

    setIsCreditServiceAgreementPopupOpen(true);
  };

  return (
    <>
      <BlurPopup
        id="popup"
        classes={{
          paper: styles.paper,
          container: styles.container,
        }}
        onClose={onClose}
        open={isModalOpen}
        scroll="body"
        blurDeep={2}
      >
        {
          <FormBody formBodyClassName={styles.popup}>
            <div className={styles.title}>Please Confirm Your Selection</div>
            {isLoading ? (
              <Loader />
            ) : (
              <>
                <LoanOfferInfo loanOffer={loanOffer} cashToYou={cashToYou} />
              </>
            )}
            <div className={styles.buttonsContainer}>
              <Button className={styles.backButton} buttonType={ButtonType.Secondary} withArrow onClick={onClose}>
                {isMobile ? '' : 'Back'}
              </Button>
              <Button
                isLoading={isLoading}
                className={styles.acceptOfferButton}
                onClick={handleOpenCreditServiceAgreementPopup}
              >
                Confirm
              </Button>
            </div>
          </FormBody>
        }
      </BlurPopup>
      {isCreditServiceAgreementPopupOpen && (
        <CreditServicesAgreementPopup
          isModalOpen={isCreditServiceAgreementPopupOpen}
          onClose={handleCloseCreditServiceAgreementPopup}
          onSubmit={handleAcceptOffer}
          lender={loanOffer.lender as unknown as Lender}
        />
      )}
    </>
  );
};

export default ConfirmOfferPopup;
